import React  from 'react';

const PolygonIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="10.117" height="8.093" viewBox="0 0 10.117 8.093">
  <path id="Polygon_7" data-name="Polygon 7" d="M5.058,0l5.058,8.093H0Z" transform="translate(10.117 8.093) rotate(180)" fill="#5ac3ff"/>
</svg>
}

export default PolygonIcon;
